import { render, staticRenderFns } from "./OngkirEmbed.vue?vue&type=template&id=27e7045a&scoped=true"
import script from "./OngkirEmbed.vue?vue&type=script&lang=js"
export * from "./OngkirEmbed.vue?vue&type=script&lang=js"
import style0 from "../assets/login.css?vue&type=style&index=0&id=27e7045a&prod&scoped=true&lang=css&external"
import style1 from "./OngkirEmbed.vue?vue&type=style&index=1&id=27e7045a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e7045a",
  null
  
)

export default component.exports